export const types = {
    CHANGE_SLIDE_MENU_POSITION: 'change_slide_menu_position',
    SET_CONTEXT_TARGET: 'set_context_target',
    CHANGE_CONTEXT_MODE: 'change_context_mode',
    HIDE_MENUS: 'hide_menus',
    SHOW_MENU: 'show_menu',
    CHANGE_STYLE_TAB: 'change_style_tab',
    EXPAND_EFFECTS_LIST: 'expand_effects_list',
    EXPAND_FONTS_LIST: 'expand_fonts_list',
    EXPAND_FONT_SIZE_LIST: 'expand_font_size_list',
    EXPAND_FONT_LINE_HEIGHT: 'expand_font_line_height',
    EXPAND_AUDIO_LIST: 'expand_audio_list',
    SELECT_MY_MEDIA_CATEGORY: 'select_my_media_category',
    SHOW_DELETE_ALERT: 'show_delete_alert',
    SHOW_ALTERNATIVE_TEXT_MENU: 'show_alternative_text_menu',
    SHOW_DELETE_TRACK_ALERT: 'show_delete_track_alert',
    SHOW_EXPORT_ALERT: 'show_export_alert',
    SHOW_PRELOADER: 'show_preloader',
    SHOW_SAVE_PRELOADER: 'show_save_preloader',
    SHOW_LOST_SESSION_ALERT: 'show_lost_session_alert',
    SHOW_ZOOM_SLIDES: 'show_zoom_slides',
    SHOW_CROPPING_MENU: 'show_cropping_menu',
    PRINT_MODE: 'print_mode',
    PRINT_TEMPLATE: 'print_template',
    USE_IMAGE_AS_BACKGROUND: 'use_image_as_background',
    USE_BACKGROUND_AS_IMAGE: 'use_background_as_image',
    USE_FRAME_AS_IMAGE: 'use_frame_as_image',
    USE_VIDEO_AS_BACKGROUND: 'use_video_as_background',
    SET_RECORDING_STATUS: 'set_recording_status',
    SHOW_DESCRIPTION: 'show_description',
    EXIT_ALERT: 'exit_alert',
    HAS_NOT_ACCESS: 'hasNotAccess',
    CHANGE_CLIPART_CATEGORY: 'change_clipart_category',
    SHOW_VIDEO_EDITOR: 'show_video_editor',
    UPDATE_CONTROL_POINT: 'update_control_point',
    REFRESH_VIDEO_EDITOR: 'refresh_video_editor',
    CHANGE_DRAWING_PROPERTIES: 'change_drawing_properties',
    GROUP_DRAWING_SHAPES: 'group_drawing_shapes',
    SHOW_AUDIO_EDITOR: 'show_audio_editor',
    SHOW_ADVANCED_MODE_ALERT: 'show_advanced_mode_alert',
    CHANGE_AUDIO_TAB_INDEX: 'change_audio_tab_index',
    CHANGE_CARTOONIST_TAB_INDEX: 'change_cartoonist_tab_index',
    EXPAND_CLIPART_IOS_BUTTONS: 'expand_clipart_ios_buttons',
    SHOW_AUDIO_ALERT: 'show_audio_alert',
    SET_BUTTONS_HOLDER_WIDTH: 'set_buttons_holder_width',
    UPDATE_CURRENT_SLIDE_CONTENT: 'update_current_slide_content',
    SHOW_RECORDER: 'show_recorder',
    SHOW_TEXT_EDITOR: 'show_text_editor',
    SHOW_MAIN_UNIVERSE: 'show_main_universe',
    REFRESH_THEME_SELECTOR: 'refresh_theme_selector',
    REFRESH_TEXT_EDITOR_TOOL: 'refresh_text_editor_tool',
    REFRESH_SHAPE_POSITION: 'refresh_shape_position'
};

export function changeSlideMenuPosition(left) {
    return { type: types.CHANGE_SLIDE_MENU_POSITION, left};
}

export function setContextTarget(model, visibleShapeMenu = true) {
    return { type: types.SET_CONTEXT_TARGET, model, visibleShapeMenu};
}

export function changeContextMode(mode) {
    return { type: types.CHANGE_CONTEXT_MODE, mode};
}

export function hideMenus(menuTypes) {
    return { type: types.HIDE_MENUS, menuTypes};
}

export function showMenu(menuType) {
    return { type: types.SHOW_MENU, menuType};
}

export function changeStyleTab(selectedTab) {
    return { type: types.CHANGE_STYLE_TAB, selectedTab};
}

export function expandEffectsList(isExpanded) {
    return { type: types.EXPAND_EFFECTS_LIST, isExpanded};
}

export function expandFontsList(isExpanded) {
    return { type: types.EXPAND_FONTS_LIST, isExpanded};
}

export function expandFontSizeList(isExpanded) {
    return { type: types.EXPAND_FONT_SIZE_LIST, isExpanded};
}

export function expandFontLineHeight(isExpanded) {
    return { type: types.EXPAND_FONT_LINE_HEIGHT, isExpanded};
}

export function expandAudioList(isExpanded, listType) {
    return { type: types.EXPAND_AUDIO_LIST, isExpanded, listType};
}

export function selectMyMediaCategory(category) {
    return { type: types.SELECT_MY_MEDIA_CATEGORY, category};
}

export function showDeleteAlert(value) {
    return { type: types.SHOW_DELETE_ALERT, value};
}

export function showAlternativeTextMenu(value) {
    return { type: types.SHOW_ALTERNATIVE_TEXT_MENU, value};
}

export function showDeleteTrackAlert(value) {
    return { type: types.SHOW_DELETE_TRACK_ALERT, value};
}

export function showAdvancedModeAlert(value) {
    return { type: types.SHOW_ADVANCED_MODE_ALERT, value};
}

export function showExportAlert(value) {
    return { type: types.SHOW_EXPORT_ALERT, value};
}

export function showLostSessionAlert(value) {
    return { type: types.SHOW_LOST_SESSION_ALERT, value};
}

export function showPreloader(value) {
    return { type: types.SHOW_PRELOADER, value};
}

export function showSavePreloader(value) {
    return { type: types.SHOW_SAVE_PRELOADER, value};
}

export function showZoomSlides(value) {
    return { type: types.SHOW_ZOOM_SLIDES, value};
}

export function showCroppingMenu(value) {
    return { type: types.SHOW_CROPPING_MENU, value};
}

export function printMode(value) {
    return { type: types.PRINT_MODE, value};
}

export function printTemplate(value) {
    return { type: types.PRINT_TEMPLATE, value};
}

export function useImageAsBackground(value) {
    return { type: types.USE_IMAGE_AS_BACKGROUND, value};
}

export function useBackgroundAsImage(value) {
    return { type: types.USE_BACKGROUND_AS_IMAGE, value};
}

export function useFrameAsImage(value) {
    return { type: types.USE_FRAME_AS_IMAGE, value};
}

export function useVideoAsBackground(value) {
    return { type: types.USE_VIDEO_AS_BACKGROUND, value};
}

export function setRecordingStatus(recordingStatus) {
    return { type: types.SET_RECORDING_STATUS, recordingStatus};
}

export function showDescription(value) {
    return { type: types.SHOW_DESCRIPTION, value};
}

export function exitAlert(value) {
    return { type: types.EXIT_ALERT, value};
}

export function hasNotAccess(value) {
    return { type: types.HAS_NOT_ACCESS, value};
}

export function changeClipartCategory(value) {
    return { type: types.CHANGE_CLIPART_CATEGORY, value};
}

export function showVideoEditor(value) {
    return { type: types.SHOW_VIDEO_EDITOR, value};
}

export function updateControlPoint(value) {
    return { type: types.UPDATE_CONTROL_POINT, value};
}

export function refreshVideoEditor(value) {
    return { type: types.REFRESH_VIDEO_EDITOR, value};
}

export function changeDrawingProperties(property, value) {
    return { type: types.CHANGE_DRAWING_PROPERTIES, property, value};
}

export function groupDrawingShapes(value) {
    return { type: types.GROUP_DRAWING_SHAPES, value};
}

export function showAudioEditor(value) {
    return { type: types.SHOW_AUDIO_EDITOR, value};
}

export function changeAudioTabIndex(index) {
    return { type: types.CHANGE_AUDIO_TAB_INDEX, index};
}

export function changeCartoonistTabIndex(index) {
    return { type: types.CHANGE_CARTOONIST_TAB_INDEX, index};
}

export function expandClipartIOSButtons(value) {
    return { type: types.EXPAND_CLIPART_IOS_BUTTONS, value};
}

export function showAudioAlert(value, title) {
    return { type: types.SHOW_AUDIO_ALERT, value, title};
}

export function setButtonsHolderWidth(value) {
    return { type: types.SET_BUTTONS_HOLDER_WIDTH, value};
}

export function updateCurrentSlideContent(value) {
    return { type: types.UPDATE_CURRENT_SLIDE_CONTENT, value};
}

export function showRecorder(value) {
    return { type: types.SHOW_RECORDER, value};
}

export function showTextEditor(textShape) {
    return { type: types.SHOW_TEXT_EDITOR, textShape};
}

export function showMainUniverse(value) {
    return { type: types.SHOW_MAIN_UNIVERSE, value};
}

export function refreshThemeSelector() {
    return { type: types.REFRESH_THEME_SELECTOR};
}

export function refreshTextEditorTool() {
    return { type: types.REFRESH_TEXT_EDITOR_TOOL};
}

export function refreshShapePosition(uuid) {
    return { type: types.REFRESH_SHAPE_POSITION, uuid};
}



/** WEBPACK FOOTER **
 ** ./src/actions/MenuActions.js
 **/